module.exports = __webpack_public_path__ + "img/connections.7b05a4a2.png";